import React from "react";
import Link from "gatsby-link";
import Imgix from "react-imgix";
import cx from "classnames";
import { ButtonTextNoLink } from "../Buttons";
import { endSlash } from "../../util/helperFunctions";


const ListGridItem = ({ page, full }) => {
  return (
    <div
      className={cx("list-grid-item flex mb1 mb0-m mw-1060 center-m relative", {
        "list-grid-item--full": full
      })}
    >
      {!full && (
        <Link
          to={endSlash(page.route)}
          className="list-grid-item__info bg-stone dark relative flex flex-column justify-between"
        >
          <div>
            <h2 className="p-averta p-lead-averta--m h-2--l">{page.title}</h2>
            {page.abstract && (
              <p className="p--small mt1-l p--m ttu-m h-3--l mbo">
                {page.abstract}
              </p>
            )}
          </div>
          <div className="flex jusitfy-start items-center">
            <ButtonTextNoLink className="o-40 dark" />
          </div>
        </Link>
      )}
      <Link
        to={endSlash(page.route)}
        className={cx("list-grid-item__image bg-blue flex ml0 mt2-m mt3-l", {
          "list-grid-item__image--full": full
        })}
      >
        {page.abstractPhoto && (
          <Imgix
            type="img"
            src={page.abstractPhoto.url}
            className="w-100 h-100 image-cover mb0"
            imgixParams={{
              "max-h": 530,
              "max-w": full ? 1060 : 530,
              "fp-x": page.abstractPhotoFocalPointX,
              "fp-y": page.abstractPhotoFocalPointY,
              auto: ["compress"],
              fit: "crop",
              crop: "focalpoint",
              bri: full ? "-20" : null
            }}
            htmlAttributes={{
              alt: page.abstractPhotoAltText
            }}
          />
        )}
        {full && (
          <div className="list-grid-item__info list-grid-item__info--full">
            <h2 className="p-averta p-lead-averta--m h-2--l">{page.title}</h2>
            {page.abstract && (
              <p className="p--small mt1 p--m ttu-m h-3--l mbo">
                {page.abstract}
              </p>
            )}
            <div className="mt1">
              <ButtonTextNoLink className="white" />
            </div>
          </div>
        )}
      </Link>
    </div>
  );
};

export default ListGridItem;



// WEBPACK FOOTER //
// ./src/components/PageHelpers/ListGridItem.js